// src/config/appConfig.js
const raw = (process.env.REACT_APP_API_URL || '').trim();   // ← guard
const cleanBase = raw.replace(/\/+$/, '');
if (process.env.NODE_ENV === 'production' && (!cleanBase || !cleanBase.startsWith('https://'))) {
  throw new Error('Production builds require REACT_APP_API_URL to use HTTPS.');
}
const satelliteStyleUrl = (process.env.REACT_APP_SATELLITE_TILE_URL || '').trim();
const topographicStyleUrl = (process.env.REACT_APP_TOPOGRAPHIC_TILE_URL || '').trim();
const readMapTilerKey = (url) => {
  if (!url) return '';
  try {
    return new URL(url).searchParams.get('key') || '';
  } catch {
    return '';
  }
};
const mapTilerKey =
  (process.env.REACT_APP_MAPTILER_KEY || '').trim() ||
  readMapTilerKey(satelliteStyleUrl) ||
  readMapTilerKey(topographicStyleUrl);

const appConfig = {
  appName: 'gisapp',
  apiBaseUrl: cleanBase || 'http://127.0.0.1:8000', // fallback only if env not set
  maxUploadSize: 20 * 1024 * 1024,
  supportedFileTypes: ['jpg', 'jpeg', 'png', 'gif', 'pdf'],
  timeoutDuration: 30000,
  defaultLanguage: 'en',
  availableLanguages: ['en', 'ar'],
  features: { enableNotifications: true, enableDarkMode: true, enableOfflineMode: false },
  maps: {
    mapTilerKey,
    satelliteStyleUrl,
    topographicStyleUrl,
  },
  auth: {
    tokenStorageKey: 'rayat_auth_token',
    refreshTokenStorageKey: 'rayat_refresh_token',
    userStorageKey: 'rayat_user',
    sessionTimeout: 3600000,
    loginEndpoint: '/auth/login',
    registerEndpoint: '/auth/register',
    refreshEndpoint: '/auth/refresh',
    logoutEndpoint: '/auth/logout',
    logoutAllEndpoint: '/auth/logout-all',
    googleEndpoint: '/auth/google',
    googleClientId: (process.env.REACT_APP_GOOGLE_CLIENT_ID || '').trim()
  }
};

// if (!raw) console.warn('REACT_APP_API_URL not set; using http://localhost:8000');

export default appConfig;
